module.exports = __webpack_public_path__ + "media/images/slide-22-942c66cf682d4a7f05c82eeb68f490fd.jpg";